function WaitingPosts() {
  return <>waiting posts</>;
}

export default WaitingPosts;
